import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, race, Subject, timer } from 'rxjs';
import { exhaustMap, mapTo, take, takeUntil } from 'rxjs/operators';
import { LongEscapeTipComponent } from './long-escape-tip/long-escape-tip.component';
import { LongEscapeComponent, longPressTimeInMs } from './long-escape/long-escape.component';

@Directive({
  selector: '[saLongEscape]',
})
export class LongEscapeDirective implements OnInit, OnDestroy {
  @Input() public routerLink: string | string[];
  @Input() public longEscapeAction: () => void;
  @Input() public showTooltip = true;
  @Output() public longPressed: EventEmitter<MouseEvent> = new EventEmitter();
  public keyDown$$ = new Subject();
  public keyUp$$ = new Subject();
  private destroys$$ = new Subject();
  private snackBarRef: MatSnackBarRef<any>;

  constructor(private snackBar: MatSnackBar, private router: Router, private activatedRoute: ActivatedRoute) {}

  public ngOnInit() {
    this.keyDown$$
      .asObservable()
      .pipe(
        exhaustMap(() => {
          this.snackBarRef = this.snackBar.openFromComponent(LongEscapeComponent, {
            panelClass: 'hotkey-snackbar',
          });
          return combineLatest(
            race(this.keyUp$$.pipe(mapTo(false)), timer(longPressTimeInMs).pipe(take(1), mapTo(true))).pipe(take(1)),
            this.keyUp$$.asObservable(),
          ).pipe(take(1));
        }),
        takeUntil(this.destroys$$),
      )
      .subscribe(([isLongPress]) => {
        if (this.snackBarRef) {
          this.snackBarRef.dismiss();
        }
        if (isLongPress) {
          if (this.routerLink) {
            if (typeof this.routerLink === 'string') {
              this.router.navigateByUrl(this.routerLink);
            } else {
              this.router.navigate(this.routerLink, { relativeTo: this.activatedRoute });
            }
            return;
          }
          this.longPressed.next();
        }
      });
  }

  public ngOnDestroy() {
    this.destroys$$.next();
    this.destroys$$.unsubscribe();
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
  }

  @HostListener('click', ['$event'])
  public click($event) {
    if (window.innerWidth > 1024 && this.showTooltip) {
      this.snackBar.openFromComponent(LongEscapeTipComponent, {
        duration: 2000,
        panelClass: 'hotkey-snackbar',
      });
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  public keyDown(event: KeyboardEvent) {
    this.keyDown$$.next(event);
  }

  @HostListener('document:keyup.escape', ['$event'])
  public keyUp(event: KeyboardEvent) {
    this.keyUp$$.next(event);
  }
}
